import { FC, ReactNode } from 'react';

import { Box, Center, FormLabel, InformationCircleOutline, Tooltip } from '@bonusly/design-system';

type InfoLabelProps = {
	children: ReactNode;
	isOptional?: boolean;
	label?: string;
};

export const InfoLabel: FC<InfoLabelProps> = ({ children, isOptional = false, label }) => {
	return (
		<FormLabel
			{...(isOptional && {
				_after: {
					content: '"Optional"',
					color: 'text.softest',
					float: 'right',
				},
			})}
			style={{ opacity: 'unset' }}
		>
			<Box as="span" display="inline-flex" alignItems="center">
				{children}
				{label && (
					<Tooltip label={label} hasArrow>
						<Center>
							<InformationCircleOutline size="xs" ml={1} />
						</Center>
					</Tooltip>
				)}
			</Box>
		</FormLabel>
	);
};
